import { type ReactElement } from 'react';
import { type SapaMessageItemType } from 'types/sapa';
import SapaMessage from './SapaMessage';

interface UserMessageProps {
  message: SapaMessageItemType;
}

const UserMessage = ({ message }: UserMessageProps): ReactElement => (
  <div key={message.id} className="mb-4">
    <SapaMessage isUser date={new Date().toLocaleTimeString()}>
      {message.content}
    </SapaMessage>
  </div>
);

export default UserMessage;
